// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import Tooltip from '../../../../elements/Tooltip/Tooltip';
import { groupItems } from '../../../new-order/QuoteStep/utils';
import { LoadingContentStripe } from '../../../../elements/LoadingContentFigures/LoadingContentFigures';
import classNames from 'classnames/bind';
import moment from 'moment';

import style from './ReserveSummary.scss';
import icons from '../../../../assets/styles/icons.scss';
import loadingStripeStyle from '../../../../elements/LoadingContentFigures/LoadingContentFigures.scss';

import type { BagItem, Order, ShoppingCartItem } from '../../../../entities';
import type { ItemsByStore } from '../../../new-order/QuoteStep/components/QuoteSummary/QuoteSummary';

type Item = ShoppingCartItem | BagItem;

type Props = {
  order: Order;
};

type State = {
  openShipping: boolean;
};

export const ReserveSummaryLoading = () => (
  <section className={style.summaryWrap}>
    <FormattedMessage id="reserve.summary.title.orderDetail">{
      txt => <h3 className={style.title}>{txt}</h3>
    }</FormattedMessage>
    <article className={classNames(style.wrap, style.loadingStripesWrap)}>
      <LoadingContentStripe colorClassName={loadingStripeStyle.black100}/>
    </article>
    <article className={classNames(style.wrap, style.loadingStripesWrap)}>
      <LoadingContentStripe colorClassName={loadingStripeStyle.black100}/>
    </article>
    {/*<section className={classNames(style.shippingContent, style.loading)}>
      <article className={style.wrap}>
        <FormattedMessage id="reserve.summary.shipping">{
          txt => <span>{txt}</span>
        }</FormattedMessage>
        <LoadingContentStripe colorClassName={classNames(loadingStripeStyle.black100, style.loadingStripeTotal)}/>
      </article>
    </section>
    <article className={classNames(style.wrap, style.loadingStripesWrap)}>
      <LoadingContentStripe colorClassName={loadingStripeStyle.black100}/>
    </article>
    <article className={classNames(style.wrap, style.loadingStripesWrap)}>
      <LoadingContentStripe colorClassName={loadingStripeStyle.black100}/>
    </article>*/}
    <article className={style.wrap}>
      <FormattedMessage id="reserve.summary.total">{
        txt => <span className={style.total}>{txt}</span>
      }</FormattedMessage>
      <LoadingContentStripe colorClassName={classNames(loadingStripeStyle.black200, style.loadingStripeTotal)}/>
    </article>
  </section>);

export default class ReserveSummary extends Component<Props, State> {
  state = {
    openShipping: false,
  };

  render() {
    const { order } = this.props;
    const { openShipping } = this.state;
    const itemsByStores: ?ItemsByStore[] = order && groupItems(order.items);
    return (
      <Fragment>
        <section className={style.summaryWrap}>
          <FormattedMessage id="reserve.summary.title.orderDetail">{
            txt => <h3 className={style.title}>{txt} #{order && order.id}</h3>
          }</FormattedMessage>
          <section className={style.deliveryWrap}>
            <i className={icons.iconDeliverBoxMedium}/>
            <FormattedMessage id="newOrder.quote.classic.deliveryTime.estimatedDate">{
              txt => <span>{txt}:</span>
            }</FormattedMessage>
            <span>{moment(order.beforeDate).utc().format('MMM DD, YYYY', { trim: false })}</span>
          </section>
          <article className={style.wrap}>
            <FormattedMessage id="reserve.summary.value">{
              txt => <span className={style.withTooltip}>
                {txt}: <Tooltip id="product"
                                intl="order.sale.summary.value.tooltip"/>
              </span>
            }</FormattedMessage>
            <span>$ {order && order.invoice.detail.subtotal}</span>
          </article>
          {/*<article className={classNames(style.shipping, style.wrap, { [style.open]: openShipping })}
                   onClick={_ => this.setState((state: State) => ({ openShipping: !state.openShipping }))}>
            <FormattedMessage id="reserve.summary.shipping">{
              txt => <span><i className={classNames(
                { [icons.iconChevronUpMedium]: openShipping },
                { [icons.iconChevronDownMedium]: !openShipping })}/> {txt}</span>
            }</FormattedMessage>
            <span>{`$ ${order && order.invoice.detail.shipping}`}</span>
          </article>
          {openShipping && <section className={style.shippingContent}>
            {itemsByStores && itemsByStores.map((x: ItemsByStore, i: number) => {
              const s = x.items.reduce((acum: number, i: Item) => acum + parseFloat(i.shipping), 0).toFixed(2);
              const a = x.items.reduce((acum: number, i: Item) => acum + i.amount, 0);
              return <article key={i}
                              className={style.wrap}>
                <span className={style.shippingContentText}>({a}) {x.name}</span>
                <span className={style.shippingContentText}>$ {s}</span>
              </article>;
            })}
          </section>*/}
          <article className={style.wrap}>
            <FormattedMessage id="reserve.summary.taxes">{
              txt => <span>{txt}:</span>
            }</FormattedMessage>
            <span>{`$ ${order && order.invoice.detail.taxes}`}</span>
          </article>
          {order &&
          order.invoice.detail.customsDuties &&
          order.invoice.detail.customsDuties !== '0.00' &&
          <article className={style.wrap}>
            <FormattedMessage id="reserve.summary.customsDuties">{
              txt => <span>{txt}:</span>
            }</FormattedMessage>
            <span>{`$ ${order && order.invoice.detail.customsDuties}`}</span>
          </article>}
          <article className={style.wrap}>
            <FormattedMessage id="reserve.summary.commission">{
              txt => <span>{txt}: <Tooltip id="commission" intl="order.sale.summary.commission.tooltip"/></span>
            }</FormattedMessage>
            <span>{`$ ${order && order.invoice.detail.commission}`}</span>
          </article>
          <hr/>
          <article className={style.wrap}>
            <FormattedMessage id="reserve.summary.total">{
              txt => <span className={classNames(style.total, style.orange)}>
                {txt}: <Tooltip id="total"
                                intl="order.sale.summary.total.tooltip"/>
              </span>
            }</FormattedMessage>
            <span className={classNames(style.total, style.orange)}>{`$ ${order.invoice.detail.total}`}</span>
          </article>
        </section>
        <FormattedMessage id="reserve.summary.note">{
          txt => <p className={style.summaryNote}>{txt}</p>
        }</FormattedMessage>
      </Fragment>
    );
  }
}

ReserveSummary.propTypes = {
  order: PropTypes.object,
};

ReserveSummary.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/reserve/components/ReserveSummary/ReserveSummary.jsx